import React /*, { useEffect, useRef, useState }*/ from 'react';
import { Table as BulmaTable } from '@codeparva/ui-components-library';

interface Props {
  columns: IColumn[];
  data: any;
  formatterProps?: any;
  tableProps?: any;
}

interface IColumn {
  key: string;
  label: string;
  formatter?: (value: any) => {};
  width?: number;
}

export const Table: React.FC<Props> = ({
  columns,
  data,
  formatterProps,
  tableProps,
}) => {
  const { tableWidth } = tableProps || {};

  return (
    <div style={{ width: tableWidth, overflow: 'auto' }}>
      <BulmaTable className="table is-fullWidth is-narrow">
        <thead className="tableHeader">
          <tr>
            {columns.map((column: IColumn, index: number) => (
              <th
                className="is-vcentered"
                key={index}
                style={{ width: column.width || `${100 / columns.length}%` }}
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="tableBody">
          {data.map((rowData: any, rowIndex: number) => {
            console.log(`rowData[${rowIndex}]:`, rowData);
            return (
              <tr key={rowIndex}>
                {columns.map((column: IColumn, colIndex: number) => {
                  console.log(`colData[${colIndex}]:`, rowData[column.key]);
                  return (
                    <td
                      className="is-vcentered"
                      key={colIndex}
                      style={{
                        width: column.width || `${100 / columns.length}%`,
                      }}
                    >
                      {column.formatter
                        ? column.formatter({
                            data: rowData[column.key],
                            formatterProps,
                          })
                        : rowData[column.key]}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </BulmaTable>
    </div>
  );
};
